// The HUD's element lookup and deduped writes, shared by src/hud.ts and src/pilotPanel.ts.

function req<T extends Element>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`HUD: missing element #${id}`);
  return el as unknown as T;
}

/**
 * The last value written per element and property: a per-frame write whose
 * string is unchanged still dirties style and layout. Radar pips and throttle
 * ticks are pooled and keyed at their own call sites instead.
 */
type HudWritten = { text: string | null; style: Map<string, string>; cls: Map<string, boolean> };

const hudWritten = new WeakMap<Element, HudWritten>();

function written(el: Element): HudWritten {
  const existing = hudWritten.get(el);
  if (existing) return existing;
  const fresh: HudWritten = { text: null, style: new Map(), cls: new Map() };
  hudWritten.set(el, fresh);
  return fresh;
}

function setText(el: HTMLElement, text: string): void {
  const w = written(el);
  if (w.text === text) return;
  w.text = text;
  el.textContent = text;
}

function setStyle(el: HTMLElement, prop: string, value: string): void {
  const w = written(el);
  if (w.style.get(prop) === value) return;
  w.style.set(prop, value);
  el.style.setProperty(prop, value);
}

function setClass(el: Element, name: string, on: boolean): void {
  const w = written(el);
  if (w.cls.get(name) === on) return;
  w.cls.set(name, on);
  el.classList.toggle(name, on);
}

export { req, setClass, setStyle, setText };
